export { scrollBarWidthStore as default } from '@/packages'
